var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetListClientRfpShareDocumentAll } from '@/actions/ClientRfpShareDocumentActions';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { updateRfpCliFileViewRequestAction } from '@/pages/rfp/client/RfpClientOneFileAllRoot/RfpClientOneFileAllRootReducer';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { getStatus } from '@/utils/modules/rfp/client/rfpClientViewRequestStatus';
import { professionalUnitPath } from '@/utils/router/links';
/**
 * データの取得, ローディング制御
 */
export const useRfpClientOneFileFetchAll = (args) => {
    const { dispatch, formDispatch, id, unmountRef } = args;
    /**
     * 一括送付データ（コンサル一覧）の取得を行う
     */
    const baseFetchViewRequest = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetListClientRfpShareDocumentAll({ path: { id } }, {}));
        // APIの結果をコンポーネントに渡せるように整形する
        const values = payload.list.map((item) => ({
            companyName: item.organization_name || '',
            extraTexts: item.organization_name
                ? [
                    {
                        link: item.url_code ? professionalUnitPath(item.url_code) : '',
                        text: item.organization_name || '',
                    },
                ]
                : [],
            files: item.files.map((file) => ({
                // リンククリック時にはこのIDを使ってアクセスする
                id: file.rfp_share_document_message_file_id,
                name: file.name,
            })),
            firstName: item.first_name,
            hasOffer: item.has_offer,
            id: item.id,
            imageSrc: item.photo || '',
            isProposalRequest: item.is_proposal_request,
            isShowDetailPage: item.is_show_detail_page,
            lastName: item.last_name,
            professionalId: item.professional_id,
            professionalType: item.type,
            status: getStatus({
                hasOffer: item.has_offer,
                interviewStatus: item.interview_status,
                viewRequestProposal: item.proposal,
                viewRequestStatus: item.status,
            }),
            urlCode: item.url_code || '',
        }));
        // stateに反映
        formDispatch(updateRfpCliFileViewRequestAction(values));
    }), [dispatch, id, formDispatch]);
    /**
     * 一括送付データ 取得
     */
    const { callbackPromiseEvent: fetchViewRequest, doing: isLoading } = usePromiseDoingCallback({
        promiseEvent: baseFetchViewRequest,
        unmountRef,
    });
    return {
        fetchViewRequest,
        isLoading,
    };
};
